<template>
  <div class="">
    <div class="center">
      <el-dialog
        center
        :close-on-click-modal="false"
        :visible.sync="shut"
        :title="'选择收货地址'"
        width="590px"
        @close="shut = false"
      >
        <ul class="addressChange">
          <li v-for="(e, i) in addressList" :key="i" :class="{ liChecked: liIndex == i }" @click="updateAddress(e, i)">
            <div>
              <span>收货人:&nbsp;&nbsp;</span>
              <div>{{ e.receiverName }}</div>
            </div>
            <div>
              <span>联系方式:&nbsp;&nbsp;</span>
              <div>{{ e.mobile }}</div>
            </div>
            <div>
              <span>收货地址:&nbsp;&nbsp;</span>
              <div>{{ e.province }}{{ e.city }}{{ e.district }}{{ e.details }}</div>
            </div>
            <div class="defaultShow" v-if="e.isDefault">默认地址</div>
            <div class="setDefault" @click="setDefault(i)"><i class="el-icon-circle-check"></i>&nbsp;设为默认</div>
          </li>
          <div @click="shotDown" class="nullAddress" v-if="addressList.length === 0">
            <i class="el-icon-warning"></i>&nbsp;你还没有收货地址,点击添加收货地址
          </div>
        </ul>
        <div class="dialog-footer dialog-border" slot="footer">
          <button @click="shut = false">取消</button>
          <button class="confirm" @click="confirm">确认</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Dialog } from 'element-ui'
import orderApi from '@/api/order.js'
export default {
  name: 'change-address',
  data() {
    return {
      shut: false,
      addressList: [], // 地址查询列表
      addressSave: '', // 地址保存信息
      liIndex: null // 地址选中样式
    }
  },
  watch: {
    show(e) {
      this.shut = e
    },
    shut(e) {
      if (e) {
        this.getAddressList()
      }
      this.$emit('update:show', e)
    }
  },
  props: {
    show: {
      default: false
    }
  },
  components: {
    elDialog: Dialog
  },
  /* eslint-disable */
  methods: {
    updateAddress(e, i) {
      this.liIndex = i
      this.addressSave = e
    },
    confirm() {
      if (this.liIndex === 0 || this.liIndex) {
        this.$emit('changeAddress', this.addressSave)
        this.$feedback.success('切换地址成功')
      }
      this.shut = false
      this.liIndex = null
    },
    setDefault(index) {
      orderApi
        .setDefaultAddress({
          id: this.addressList[index].id
        })
        .then((res) => {
          // 设置默认
          if (res.status === 200 && res.data === true) {
            orderApi.getAddressList().then((res) => {
              const { data } = res
              this.addressList = data || []
            })
          } else {
            this.$feedback(res.message)
          }
        })
    },
    shotDown() {
      this.shut = false
      this.liIndex = null
      this.$emit('openAdd')
    },
    getAddressList() {
      orderApi.getAddressList().then((res) => {
        const { data } = res
        // 默认地址放到第一个
        for (let i = 0; i < data.length; i++) {
          if (data[i].isDefault) {
            data.unshift(data.splice(i, 1)[0])
            this.defaultIndex = 0
            break
          }
        }
        this.addressList = data || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.addressChange {
  width: 550px;
  height: 470px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #535353;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
  font-size: 16px;
  li {
    width: 530px;
    margin-bottom: 10px;
    border: 1px solid rgba(207, 207, 207, 1);
    line-height: 30px;
    padding: 12px 5px;
    color: #666;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    span {
      float: left;
      width: 80px;
      text-align: right;
      color: #cfcfcf;
      height: 100%;
    }
    > div {
      overflow: hidden;
      div {
        float: left;
        width: 320px;
      }
    }
    .setDefault {
      position: absolute;
      right: 25px;
      bottom: 12px;
      display: none;
      cursor: pointer;
      color: #000;
    }
    .defaultShow {
      position: absolute;
      right: 25px;
      bottom: 12px;
      z-index: 2;
      width: 84px;
      background: #fff;
      text-align: right;
    }
  }
  .liChecked {
    border: 1px solid #000;
  }
  li:hover {
    span {
      color: #333;
    }
    .setDefault {
      display: block;
    }
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 45px;
  padding-bottom: 26px;
  button {
    width: 150px;
    height: 45px;
    border: 1px solid #000;
    background: #fff;
    font-size: 20px;
    line-height: 45px;
  }
  button:last-of-type {
    background: #1f1f1f;
    color: #fff;
    margin-left: 20px;
  }
}
.dialog-border {
  box-shadow: 0px -1px 0px 0px rgba(224, 224, 224, 1);
  margin: 0;
  padding-top: 25px;
}
.nullAddress {
  color: #da1e46;
  text-align: center;
  background: #f9f9f9;
  cursor: pointer;
}
::v-deep .el-dialog__footer {
  padding: 0;
}
</style>
